var exports = {
  "kL": "ChannelChatLayout.module__container___RTdZY3",
  "Yx": "ChannelChatLayout.module__messagesArea___RTdZY3",
  "gA": "ChannelChatLayout.module__textareaArea___RTdZY3",
};

module.exports = exports;
